import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-letter-of-employment-modal',
  templateUrl: './letter-of-employment-modal.component.pug',
  styleUrls: ['./letter-of-employment-modal.component.scss'],
  standalone: false
})
export class LetterOfEmploymentModalComponent implements OnInit {

  // Set via ngx-bootstrap initialState
  enabled: boolean = false;

  @Output() saveClick = new EventEmitter<boolean>();

  saving = false;
  dirty = false;
  private initialEnabled = false;

  enabledText = $localize`Enabled`;
  disabledText = $localize`Disabled`;

  constructor(public _bsModalRef: BsModalRef) { }

  ngOnInit(): void {
    this.initialEnabled = this.enabled;
  }

  onToggleChange(checked: boolean) {
    this.enabled = checked;
    this.dirty = this.enabled !== this.initialEnabled;
  }

  save() {
    this.saving = true;
    this.saveClick.emit(this.enabled);
    this._bsModalRef.hide();
  }

  cancel() {
    this._bsModalRef.hide();
  }

  closeModal() {
    this.cancel();
  }
}
